var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.90328C1 14.3778 4.24975 18.0985 8.5 18.853V12.3528H6.25V9.85303H8.5V7.85278C8.5 5.60278 9.94975 4.35328 12.0002 4.35328C12.6497 4.35328 13.3503 4.45303 13.9998 4.55278V6.85303H12.85C11.7498 6.85303 11.5 7.40278 11.5 8.10328V9.85303H13.9L13.5002 12.3528H11.5V18.853C15.7502 18.0985 19 14.3785 19 9.90328C19 4.92553 14.95 0.853027 10 0.853027C5.05 0.853027 1 4.92553 1 9.90328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.8d132d8b2e89b78b64ccccffff03313f.svg";
export { ForwardRef as ReactComponent };